import { BotoesExportacao } from '../comuns'
import { AbaRelatorio } from '../../core/_models'
import {
  exportarAnexoIi,
  exportarIndicadoresInterconsulta,
  exportarQuantitativoInterconsulta,
  exportarRatc,
} from '../../core/_requests'
import { useParametrosRelatorios } from '../../core/ListFiltersProvider'

/** Exportações da aba visível, sempre com o filtro do momento do clique. */
export const RelatoriosListToolbar = ({ aba }: { aba: AbaRelatorio }) => {
  const { periodo, anexoIi, agrupar } = useParametrosRelatorios()

  if (aba === 'mensal')
    return (
      <BotoesExportacao
        desabilitado={!anexoIi}
        exportacoes={[
          { chave: 'csv', rotulo: 'Baixar CSV', baixar: () => exportarAnexoIi(anexoIi!, 'csv') },
          { chave: 'xlsx', rotulo: 'Baixar XLSX', baixar: () => exportarAnexoIi(anexoIi!, 'xlsx') },
          { chave: 'json', rotulo: 'Baixar JSON', baixar: () => exportarAnexoIi(anexoIi!, 'json') },
        ]}
      />
    )

  if (aba === 'ratc')
    return (
      <BotoesExportacao
        desabilitado={!periodo}
        exportacoes={[
          { chave: 'csv', rotulo: 'Exportar CSV', baixar: () => exportarRatc(periodo!, 'csv') },
          { chave: 'json', rotulo: 'Exportar JSON', baixar: () => exportarRatc(periodo!, 'json') },
        ]}
      />
    )

  return (
    <BotoesExportacao
      desabilitado={!periodo}
      exportacoes={[
        {
          chave: 'csv',
          rotulo: 'Exportar CSV',
          baixar: () =>
            aba === 'quantitativo'
              ? exportarQuantitativoInterconsulta(periodo!, agrupar)
              : exportarIndicadoresInterconsulta(periodo!),
        },
      ]}
    />
  )
}
